/* MTC Arabic phonetic search engine v2 (draft theme only). No dependencies.
   Maps Arabic phonetic spellings of English dental product words / brands to the real catalog vocabulary,
   then hands an expanded query to Shopify's native search + predictive search. Product data is never modified. */
var MTCSearch = (function () {
  'use strict';
  var DIAC = /[ؐ-ًؚ-ٰٟۖ-ۭـ]/g;
  var AR = /[؀-ۿ]/;
  function digits(s) {
    return s.replace(/[٠-٩]/g, function (d) { return String(d.charCodeAt(0) - 0x0660); })
            .replace(/[۰-۹]/g, function (d) { return String(d.charCodeAt(0) - 0x06F0); });
  }
  function norm(s) {
    s = digits(String(s || '')).toLowerCase().replace(DIAC, '')
      .replace(/[أإآٱ]/g, 'ا')
      .replace(/ى/g, 'ي').replace(/ة/g, 'ه')
      .replace(/ؤ/g, 'و').replace(/ئ/g, 'ي').replace(/ء/g, '')
      .replace(/گ/g, 'ك').replace(/چ/g, 'ج').replace(/پ/g, 'ب')
      .replace(/ڤ/g, 'ف').replace(/ک/g, 'ك').replace(/ی/g, 'ي');
    return s.replace(/[^0-9a-z؀-ۿ]+/g, ' ').replace(/[،؛؟٪-٭]/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }
  function stripAr(t) {
    if (t.length > 4 && t.indexOf('ال') === 0) t = t.slice(2);
    if (t.length > 5 && /ات$/.test(t)) t = t.slice(0, -2);
    return t;
  }

  /* ---------- Arabic -> units ---------- */
  var AC = { 'ب': 'b', 'ت': 't', 'ط': 't', 'ث': 'st', 'س': 's', 'ص': 's', 'ز': 's',
    'ذ': 'sd', 'ظ': 's', 'ج': 'j', 'ش': 'x', 'ك': 'k', 'ق': 'k', 'خ': 'k', 'غ': 'k',
    'ل': 'l', 'م': 'm', 'ن': 'n', 'ر': 'r', 'ف': 'f', 'د': 'd', 'ض': 'd',
    'ه': 'h', 'ح': 'h', 'ع': '' };
  var AV = { 'ا': 'a', 'و': 'o', 'ي': 'i' };
  function arUnits(w) {
    var u = [], nc = 0;
    for (var i = 0; i < w.length; i++) {
      var ch = w[i];
      if (ch === 'ه' && i === w.length - 1 && i > 1) ch = 'ا';
      if (AV[ch] !== undefined) {
        var last = u[u.length - 1];
        if (last && last.v) last.v += AV[ch]; else u.push({ v: AV[ch] });
      } else if (AC[ch] !== undefined) {
        if (!AC[ch]) continue;
        var prev = u[u.length - 1];
        
        u.push({ c: AC[ch] }); nc++;
      }
    }
    return { u: u, nc: nc };
  }

  /* ---------- English -> units (consonant option sets + vowel runs) ---------- */
  function enUnits(w) {
    w = String(w).toLowerCase().replace(/[^a-z]/g, '');
    var longV = false; if (w.length > 3 && /[^aeiouy]e$/.test(w)) { w = w.slice(0, -1); longV = /[aeiouy][^aeiouy]$/.test(w); }
    var u = [], i = 0;
    function C(opts) { var p = u[u.length - 1]; if (p && p.c && p.c === opts) return; u.push({ c: opts }); }
    function V(ch) { var p = u[u.length - 1]; if (p && p.v !== undefined) p.v += ch; else u.push({ v: ch }); }
    while (i < w.length) {
      var c = w[i], n = w[i + 1] || '', two = c + n;
      if (two === 'ph') { C('f'); i += 2; continue; }
      if (two === 'sh') { C('x'); i += 2; continue; }
      if (two === 'th') { C('st'); i += 2; continue; }
      if (two === 'ch') { C('kxj'); i += 2; continue; }
      if (two === 'ck') { C('k'); i += 2; continue; }
      if (two === 'gh') { i += 2; continue; }
      if (two === 'qu') { C('k'); i += 2; continue; }
      if ('aeiouy'.indexOf(c) > -1) { V(c); i++; continue; }
      if (c === 'w') { V('w'); i++; continue; }
      if (c === 'h') { if (!u.length) C('h'); i++; continue; }
      if (c === 'c') { C(/[eiy]/.test(n) ? 's' : 'k'); i++; continue; }
      if (c === 'g') { C(/[eiy]/.test(n) ? 'jk' : 'kj'); i++; continue; }
      if (c === 'x') { C('k'); C('s'); i++; continue; }
      if (c === 'p' || c === 'b') { C('b'); i++; continue; }
      if (c === 'v' || c === 'f') { C('f'); i++; continue; }
      if (c === 'z' || c === 's') { C('s'); i++; continue; }
      if (c === 'q' || c === 'k') { C('k'); i++; continue; }
      if (c === 'j') { C('j'); i++; continue; }
      C(c); i++;
    }
    if (longV) { for (var q = u.length - 1; q >= 0; q--) if (u[q].v !== undefined) { u[q].long = 1; break; } }
    var nc = 0; u.forEach(function (x) { if (x.c) nc++; });
    return { u: u, nc: nc };
  }
  var PRI = { a: 'a', e: 'i', i: 'i', y: 'i', o: 'o', u: 'o', w: 'o' };
  var SEC = { a: 'i', e: 'a', i: 'a', u: 'a' };
  function vowelPts(av, b) {
    var ev = b.v, di = av.indexOf('a') > -1 && av.indexOf('i') > -1;
    if (b.long && di && /[iy]/.test(ev)) return 14;
    if (!b.long && di && ev === 'i') return 8;
    var best = -12;
    for (var x = 0; x < av.length; x++) for (var y = 0; y < ev.length; y++) {
      if (PRI[ev[y]] === av[x]) return 12;
      if (SEC[ev[y]] === av[x]) best = 6;
    }
    return best;
  }
  function consMatch(ac, ec) { for (var x = 0; x < ac.length; x++) if (ec.indexOf(ac[x]) > -1) return true; return false; }

  /* alignment score of Arabic token against English word; -Infinity if incompatible */
  function align(A, E, allowPrefix) {
    var edits = A.nc >= 4 ? 1 : 0, memo = {};
    var ecPre = [0]; for (var k = 0; k < E.u.length; k++) ecPre.push(ecPre[k] + (E.u[k].c ? 1 : 0));
    function f(i, j, e) {
      var key = i + ',' + j + ',' + e;
      if (memo[key] !== undefined) return memo[key];
      var r = -Infinity;
      if (i === A.u.length) {
        var cov = E.nc ? ecPre[j] / E.nc : 1;
        if (cov >= 1) r = A.short ? 84 : 100; else if (allowPrefix && ecPre[j] >= 2) r = 72 + 12 * cov;
        return (memo[key] = r);
      }
      var a = A.u[i], b = E.u[j];
      if (a.c) {
        if (b && b.v !== undefined) r = Math.max(r, f(i, j + 1, e));
        if (b && b.c && consMatch(a.c, b.c)) r = Math.max(r, f(i + 1, j + 1, e));
        if (e > 0 && i > 0) {
          if (b && b.c) r = Math.max(r, f(i + 1, j + 1, e - 1) - 15, f(i, j + 1, e - 1) - 15);
          r = Math.max(r, f(i + 1, j, e - 1) - 15);
        }
      } else {
        if (b && b.v !== undefined) r = Math.max(r, f(i + 1, j + 1, e) + (i === 0 ? Math.max(6, vowelPts(a.v, b)) : vowelPts(a.v, b)));
        r = Math.max(r, f(i + 1, j, e) - (i === 0 ? 6 : 18));
      }
      return (memo[key] = r);
    }
    return f(0, 0, edits);
  }

  /* ---------- Arabic letter names -> acronyms ---------- */
  var LN = { 'اي': ['a', 'i', 'e'], 'ايه': ['a'], 'بي': ['b', 'p'], 'سي': ['c'],
    'دي': ['d'], 'اف': ['f'], 'جي': ['g'], 'اتش': ['h'], 'ايتش': ['h'],
    'جاي': ['j'], 'كي': ['k'], 'كاي': ['k'], 'ال': ['l'], 'ام': ['m'],
    'ان': ['n'], 'او': ['o'], 'كيو': ['q'], 'ار': ['r'], 'اس': ['s'],
    'تي': ['t'], 'يو': ['u'], 'في': ['v'], 'دبليو': ['w'],
    'اكس': ['x'], 'واي': ['y'], 'زد': ['z'], 'زي': ['z'], 'ثري': ['3'] };

  /* ---------- index ---------- */
  var IDX = [], CUR = {}, BRAND = {}, ACR = {}, READY = false;
  function key(s) { return norm(s).replace(/\s/g, ''); }
  function build(data) {
    IDX = []; CUR = {}; BRAND = {}; ACR = {};
    (data.words || []).forEach(function (row) {
      var w = row[0], E = enUnits(w);
      if (E.nc < 1 || w.length < 3) return;
      IDX.push({ w: w, f: row[1] || 1, E: E });
      if (w.length <= 4) ACR[w.toLowerCase()] = { w: w };
    });
    (data.brands || []).forEach(function (b) {
      var k = key(b[0]);
      BRAND[k] = { name: b[0], url: b[1] };
      var E = enUnits(b[0]);
      if (E.nc >= 2) IDX.push({ w: b[0], f: 40, E: E, brand: k });
      ACR[k] = { w: b[0], brand: k };
      (b[2] || []).forEach(function (al) { CUR[key(al)] = { to: [b[0]], brand: k }; });
    });
    addCurated(data.aliases || []);
    READY = true;
  }
  function addCurated(lines) {
    if (typeof lines === 'string') lines = lines.split(/\r?\n/);
    lines.forEach(function (line) {
      var p = String(line).split(/[:=]/); if (p.length < 2) return;
      var to = p[0].split('|').map(function (s) { return s.trim(); }).filter(Boolean); if (!to.length) return;
      var bk = key(to[0]);
      p.slice(1).join(':').split(/[,،]/).forEach(function (al) {
        var k = key(al); if (k) CUR[k] = { to: to, brand: BRAND[bk] ? bk : null };
      });
    });
  }

  /* ---------- matching ---------- */
  function cur(k) { var c = CUR[k]; return c ? [{ w: c.to[0], all: c.to, score: 200, brand: c.brand, how: 'alias' }] : null; }
  function matchToken(tok) {
    var k = tok.replace(/\s/g, '');
    var hit = cur(k) || cur(stripAr(k)); if (hit) return hit;
    if (!AR.test(tok)) return [];
    var t2 = stripAr(tok), A = arUnits(t2); A.short = t2.length <= 4;
    if (A.nc < 1 || (A.nc < 2 && t2.length < 4)) return [];
    var allowPrefix = t2.length >= 3, best = {};
    for (var i = 0; i < IDX.length; i++) {
      var e = IDX[i];
      if (A.nc === 1 && e.E.nc !== 1) continue;
      var sc = align(A, e.E, allowPrefix);
      if (sc < 70) continue;
      sc += Math.log(e.f + 1) * 4 + (e.brand ? 4 : 0);
      if (!best[e.w] || best[e.w].score < sc) best[e.w] = { w: e.w, all: [e.w], score: sc, brand: e.brand || null, how: 'phonetic' };
    }
    var arr = Object.keys(best).map(function (x) { return best[x]; }).sort(function (a, b) { return b.score - a.score; });
    if (!arr.length) return [];
    var top = arr[0].score;
    return arr.filter(function (x) { return x.score >= top - 5; }).slice(0, 2);
  }
  function acronym(toks) {
    if (toks.length < 2) return null;
    var outs = [''];
    for (var i = 0; i < toks.length; i++) {
      var L = LN[toks[i]]; if (!L) return null;
      var nx = []; outs.forEach(function (o) { L.forEach(function (l) { nx.push(o + l); }); }); outs = nx.slice(0, 32);
    }
    for (var j = 0; j < outs.length; j++) if (ACR[outs[j]]) return ACR[outs[j]];
    return null;
  }
  function quote(t) { return /\s/.test(t) ? '"' + t + '"' : t; }

  function translate(raw) {
    var original = String(raw || '').trim(), n = norm(original);
    var none = { q: original, primary: original, changed: false, suggestions: [], original: original };
    if (!READY || !n || !AR.test(n)) return none;
    var toks = n.split(' '), out = [], sugg = [], any = false, i = 0;
    var acr = acronym(toks);
    if (acr) { out.push([acr.w]); sugg.push({ w: acr.w, brand: acr.brand }); any = true; i = toks.length; }
    while (i < toks.length) {
      var done = false;
      for (var span = Math.min(4, toks.length - i); span >= 2 && !done; span--) {
        var c = CUR[toks.slice(i, i + span).join('')];
        if (c) { out.push(c.to); sugg.push({ w: c.to[0], brand: c.brand }); any = true; i += span; done = true; }
      }
      if (done) continue;
      var m = matchToken(toks[i]);
      if (m.length) {
        any = true; var set = [];
        m.forEach(function (x) { x.all.forEach(function (t) { if (set.indexOf(t) < 0) set.push(t); }); });
        out.push(set); m.forEach(function (x) { if (x === m[0] || x.brand) sugg.push(x); });
      }
      i++;
    }
    if (!any) return none;
    var primary = out.map(function (alts) { return alts[0]; }).join(' ');
    var parts = [];
    if (out.length === 1) { out[0].forEach(function (a) { parts.push(quote(a)); }); }
    else parts.push(primary);
    var seen = {}, uniq = [];
    parts.forEach(function (p) { var k = p.toLowerCase(); if (!seen[k]) { seen[k] = 1; uniq.push(p); } });
    var suggestions = [], sk = {};
    sugg.forEach(function (s) {
      var b = s.brand ? BRAND[s.brand] : null, label = b ? b.name : s.w;
      if (sk[label]) return; sk[label] = 1;
      suggestions.push({ label: label, brand: !!b, url: b ? b.url : null });
    });
    return { q: uniq.join(' OR '), primary: primary, changed: true, suggestions: suggestions, original: original };
  }

  return { build: build, translate: translate, norm: norm, matchToken: matchToken, addCurated: addCurated,
    align: align, arUnits: arUnits, enUnits: enUnits, ready: function () { return READY; } };
})();

/* ---------- MTC Arabic search: storefront integration (Shopify native search + predictive search) ---------- */
(function () {
  'use strict';
  var CFG = window.MTC_SEARCH || {};
  if (CFG.enabled === false || !window.fetch) return;
  var AR = /[؀-ۿ]/;
  var loading = null;
  var baseFetch = window.fetch;
  function load() {
    if (loading) return loading;
    loading = baseFetch.call(window, CFG.vocabUrl, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var extra = String(CFG.aliases || '').split(/\r?\n/).filter(function (l) { return l.indexOf(':') > 0; });
        d.aliases = (d.aliases || []).concat(extra);
        MTCSearch.build(d);
      })
      .catch(function () { loading = null; });
    return loading;
  }
  function t(q) { return MTCSearch.ready() ? MTCSearch.translate(q) : { changed: false, q: q }; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cap(s) { return String(s).replace(/(^|\s)([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }); }
  function searchUrl(q, original) {
    return (CFG.searchUrl || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last' + (original ? '&mtc_q=' + encodeURIComponent(original) : '');
  }

  /* 1) predictive search: rewrite q sent to /search/suggest */
  var prevFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url);
      if (url && url.indexOf('/search/suggest') > -1) {
        var u = new URL(url, location.origin), q = u.searchParams.get('q') || '';
        if (AR.test(q)) {
          var self = this, args = arguments;
          return load().then(function () {
            var r = t(q);
            if (r.changed) { u.searchParams.set('q', r.q); return prevFetch.call(self, u.toString(), init); }
            return prevFetch.apply(self, args);
          });
        }
      }
    } catch (e) {}
    return prevFetch.apply(this, arguments);
  };

  /* 2) "Did you mean" / "Brand" chips at the top of the predictive dropdown */
  function chipsHtml(r) {
    var h = '<div class="mtc-dym" data-mtc-dym>', hasBrand = false;
    r.suggestions.forEach(function (s) {
      if (!s.brand) return; hasBrand = true;
      h += '<a class="mtc-dym__chip mtc-dym__chip--brand" href="' + esc(s.url) + '"><span>' + esc(CFG.t_brand || 'Brand') + ':</span> ' + esc(s.label) + '</a>';
    });
    if (!hasBrand || r.suggestions.length > 1) {
      h += '<a class="mtc-dym__chip" href="' + esc(searchUrl(r.q, r.original)) + '"><span>' + esc(CFG.t_dym || 'Did you mean') + ':</span> ' + esc(cap(r.primary)) + '</a>';
    }
    return h + '</div>';
  }
  function inject(ps) {
    var box = ps.querySelector('#predictive-search-results') || ps.querySelector('[data-predictive-search]');
    var input = ps.querySelector('input[type="search"]');
    if (!box || !input) return;
    var old = box.querySelector('[data-mtc-dym]');
    var q = input.value.trim();
    var r = (AR.test(q) && MTCSearch.ready()) ? t(q) : null;
    if (!r || !r.changed) { if (old) old.remove(); return; }
    if (old && old.getAttribute('data-q') === q) return;
    if (old) old.remove();
    box.insertAdjacentHTML('afterbegin', chipsHtml(r));
    var el = box.querySelector('[data-mtc-dym]'); if (el) el.setAttribute('data-q', q);
  }
  function watch() {
    document.querySelectorAll('predictive-search').forEach(function (ps) {
      if (ps.__mtc) return; ps.__mtc = 1;
      var input = ps.querySelector('input[type="search"]');
      if (input) input.addEventListener('focus', load, { passive: true });
      var timer;
      new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(function () { inject(ps); }, 30); })
        .observe(ps, { childList: true, subtree: true });
    });
  }

  /* 3) full search submits: translate q, keep original in mtc_q */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/search') < 0 || f.__mtcDone) return;
    var qi = f.querySelector('input[name="q"]'); if (!qi || !AR.test(qi.value)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    load().then(function () {
      var r = t(qi.value.trim());
      if (r.changed) {
        var h = f.querySelector('input[name="mtc_q"]');
        if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'mtc_q'; f.appendChild(h); }
        h.value = r.original; qi.value = r.q;
      }
      f.__mtcDone = true; f.submit();
    });
  }, true);

  /* 4) /search page: direct Arabic URLs are translated once; translated pages show a friendly notice */
  function onSearchPage() {
    if (!/\/search\/?$/.test(location.pathname)) return;
    var p = new URLSearchParams(location.search), q = p.get('q') || '', orig = p.get('mtc_q');
    if (!orig && AR.test(q) && !p.get('mtc_n')) {
      load().then(function () {
        var r = t(q);
        if (r.changed) { p.set('q', r.q); p.set('mtc_q', r.original); location.replace(location.pathname + '?' + p.toString()); }
      });
      return;
    }
    if (!orig) return;
    load().then(function () {
      var r = t(orig);
      var label = cap(r.changed ? r.primary : q);
      document.querySelectorAll('input[name="q"]').forEach(function (i) { if (i.value === q) i.value = orig; });
      var main = document.querySelector('main') || document.body, walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT), n, hits = [];
      while ((n = walker.nextNode())) if (q.indexOf(' OR ') > -1 && n.nodeValue.indexOf(q) > -1) hits.push(n);
      hits.forEach(function (x) { x.nodeValue = x.nodeValue.split(q).join(label); });
      var anchor = document.querySelector('.template-search__search') || document.querySelector('.template-search__header');
      if (anchor && !document.querySelector('[data-mtc-note]')) {
        var note = '<div class="mtc-dym mtc-dym--page" data-mtc-note><span>' + esc(CFG.t_showing || 'Showing results for') + ' <b>' + esc(label) + '</b> &middot; ' +
          esc(CFG.t_typed || 'you typed') + ' “' + esc(orig) + '”</span>';
        (r.suggestions || []).forEach(function (s) { if (s.brand) note += ' <a class="mtc-dym__chip mtc-dym__chip--brand" href="' + esc(s.url) + '"><span>' + esc(CFG.t_brand || 'Brand') + ':</span> ' + esc(s.label) + '</a>'; });
        anchor.insertAdjacentHTML('afterend', note + '</div>');
      }
    });
  }

  function init() { watch(); onSearchPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.MTCSearchLoad = load;
})();
